import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import axios from 'axios';
import { Alert, Row, Col, Form, FormControl } from 'react-bootstrap';
import Snackbar from '@material-ui/core/Snackbar';
import { Button } from '@material-ui/core';
import _get from 'lodash/get';
import MuiAlert from '@material-ui/lab/Alert';
import Header from '../header/Header';
import {
  Container,
  HomeButtons,
  Wrapper,
  SmallButton
} from '../../styles/HomeStyles';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import { config } from '../../config';
import { Toast } from '../student/Home';

export default function ActivateAccount(props) {
  const [status, setStatus] = useState('');
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertFailure, setAlertFailure] = useState(false);

  const { token } = props.match.params;

  useEffect(() => {
    axios
      .get(`${config.API_URL}/user/auth/verify-email/${token}`)
      .then(response => {
        setStatus(_get(response, 'data.data.message', ''));
        setAlertSuccess(true);
        // setApprovedCourses(response.data.data);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('There was an problem validating your email');
        setAlertFailure(true);
      });
  }, []);

  const successAlert = (
    <Alert variant="success">
      <Alert.Heading>Email sent </Alert.Heading>
      <p>
        We send you an email with reset password link. Please check your email.
      </p>
      <p>
        Please try again or contact us if you do not receive it within a few
        minutes.
      </p>
    </Alert>
  );

  const handleClose = (event, reasons) => {
    if (reasons === 'clickaway') {
      return;
    }
    setAlertFailure(false);
    setAlertSuccess(false);
  };

  return (
    <Container>
      <Header isHome={true} center={true} />
      <Wrapper>
        <Snackbar
          open={alertFailure}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="error">
            {status}
          </Toast>
        </Snackbar>
        <Snackbar
          open={alertSuccess}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="success">
            {status}
          </Toast>
        </Snackbar>
        <h2 style={{ textAlign: 'center' }}>{status}</h2>
        <Label>
          <Link to="/login">Proceed to Login</Link>
        </Label>
      </Wrapper>
    </Container>
  );
}
